import AxiosAPI from "./AxiosAPI";

export const fetchProductGroup = async () => {
  try {
    const response = await AxiosAPI.get("/catalog/productGroup");
    return response.data;
  } catch (error) {
    console.log(error,"while fetching the customers")
    throw error.response?.data || error;
  }
};


export const handleAddProductGroup = async (data) => {
  try {
    const response = await AxiosAPI.post("/catalog/productGroup", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add product group:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditProductGroup= async (key,data) => {  
  try {
    const response = await AxiosAPI.put(
      `/catalog/productGroup/${key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};



export const deleteProductGroup = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/catalog/productGroup/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};

